module.exports = __webpack_public_path__ + "static/media/healthinsurance.b09a7b5a.png";